<template>
    <div>
        <div class="content-tip">
            <p>
                收入水平与保险需求之间存在显著的正相关关系，
            </p>
            <p>
                了解您{{
                    mateMember ? "和配偶" : ""
                }}的税后收入情况，才能配置最适合您家庭的保险保障哦~
            </p>
        </div>

        <div v-for="(item, i) in members" :key="i">
            <div class="title">请问您{{ item.nickname }}的税后月收入是？</div>
            <div class="flex-box" style="padding-bottom:.2rem">
                <div class="form-box">
                    <input
                        type="number"
                        :value="item.income"
                        placeholder="请输入"
                        @input="(e) => inputChange(e, i, item)"
                    />
                    <div
                        class="err-tip"
                        style="color:#999999;"
                        v-if="!errTips[i] && item.income >= 10000"
                    >
                        * {{ parseInt(item.income / 10000) }}万{{
                            /[\.]/.test(item.income / 10000) ? "+" : ""
                        }}
                    </div>
                    <div class="err-tip" v-if="errTips[i]">
                        * {{ errTips[i] }}
                    </div>
                </div>
                <div style="font-size: 0.14rem;">元</div>
            </div>

            <br />
        </div>

        <div class="flex-box next-box">
            <div @click="back">上一步</div>
            <div
                @click="onClickNext"
                class="btn-next"
                :class="{ gray: !nextPass }"
                sensor-click
            >
                填好了
            </div>
        </div>
    </div>
</template>

<script>
import { SELF, MATE, CHILD } from "../../../../enum/RELATION.js";
import Validator from "cignacmb-validator";

const validateSchema = {
    type: "object",
    properties: {
        income: {
            type: "number",
            rules: [
                {
                    validate({ value, isNotEmpty }) {
                        return [isNotEmpty(value), "税后月收入为必填"];
                    },
                },
                {
                    premise: function({ parent }) {
                        return parent.relation == SELF;
                    },
                    validate({ value }) {
                        return [
                            value <= 99999999 && value >= 100,
                            "税后月收入需在100元与99,999,999元之间；",
                        ];
                    },
                },
                {
                    premise: function({ parent }) {
                        return parent.relation == MATE;
                    },
                    validate({ value }) {
                        return [
                            value <= 99999999 && value >= 0,
                            "税后月收入需在0元与99,999,999元之间；",
                        ];
                    },
                },
            ],
        },
    },
};
const nestedSchema = {
    type: "array",
    items: validateSchema,
};
export default {
    props: {
        index: Number, // 题目顺序
        updateAnswer: Function, // 更新答案
        next: Function,
        back: Function,
        member: Array,
    },
    data() {
        this.SELF = SELF;
        this.MATE = MATE;

        this.validator = new Validator(nestedSchema);
        this.validator.onError(({ path, msg }) => {
            const [index] = path.split(".");
            this.$set(this.errTips, index, msg);

            console.log(path, msg, "onError");
        });

        this.validator.onSuccess(({ path, msg }) => {
            const [index] = path.split(".");
            this.$set(this.errTips, index, "");
        });

        this.passValidator = new Validator(nestedSchema);
        return {
            errTips: [],
            nextPass: false,
        };
    },
    watch: {
        member: {
            deep: true,
            immediate: true,
            handler(n, o) {
                this.passValidator
                    .run({
                        originData: this.members,
                        mode: "stop",
                    })
                    .finally(() => (this.nextPass = false))
                    .then(() => (this.nextPass = true));
            },
        },
    },
    computed: {
        mateMember() {
            return this.members.find((item) => item.relation == MATE) || false;
        },
        members() {
            return this.member
                .map((item, index) => {
                    item.relation == MATE && (item["nickname"] = "配偶");
                    item.index = index;
                    return item;
                })
                .filter((item) => item.checked && item.relation != CHILD);
        },
    },
    methods: {
        onClickNext(e) {
            const text = e.target.innerText;
            this.sensorsAdd("BDWebClick", {
                $element_content: text,
                $title: `测评页-第${this.index}题`,
            });

            this.sensorsAdd("BDanswerResult", {
                entrance_location: "",
                question_number: this.index,
                question: `您${this.members.reduce(
                    (str, item) => `${str}${str && "-"}${item.nickname || ""}`,
                    ""
                )}的税后月收入是？`,
                answer: this.members.reduce(
                    (str, item) => `${str}${str && "-"}${item.income}`,
                    ""
                ),
            });
            // 执行校验
            this.validator
                .run({
                    originData: this.members,
                    mode: "stop",
                })
                .then((data) => {
                    // 校验通过执行next方法
                    this.next();
                });
        },
        inputChange(e, i, item) {
            this.updateAnswer(item.index, e.target.value);
            new Validator(validateSchema)
                .run({
                    originData: item,
                    mode: "stop",
                })
                .then(
                    () => this.$set(this.errTips, i, ""),
                    ({ income }) => this.$set(this.errTips, i, income)
                );
        },
    },
};
</script>

<style scoped>
.flex-box {
    display: flex;
    justify-content: center;
    align-items: center;
}
.next-box {
    margin-top: 1.5rem;
    width: 100%;
    justify-content: space-between;
    padding: 0 0.2rem 0.2rem;
    box-sizing: border-box;
    background: transparent;
}
.next-box > div {
    padding: 0.06rem 0.16rem;
    font-size: 0.13rem;
    font-weight: 500;
    color: #bbc3ca;
    line-height: 0.19rem;
}
.next-box > div:nth-child(1) {
    border-radius: 0.15rem;
    border: 1px solid #3b97ff;
    color: #3b97ff;
    background: white;
}
.next-box .btn-next {
    font-size: 0.14rem;
    color: #ffffff;
    background: #3b97ff;
    border-radius: 0.15rem;
}

.form-box {
    display: inline-block;
    position: relative;
}

input {
    width: 1.74rem;
    font-size: 0.19rem;
    font-family: PingFang SC;
    color: #0f2742;
    line-height: 0.19rem;
    padding: 0.1rem 0;
    background-color: transparent;
    border: 1px solid transparent;
    border-bottom-color: #eeee;
    text-align: center;
}
input:focus {
    outline: none;
}
.err-tip {
    width: 150%;
    text-align: center;
    font-size: 0.12rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #f34747;
    line-height: 0.19rem;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%) translateY(150%);
}
</style>
